import Glide from '@glidejs/glide';

const firstBitesSlider = document.querySelector('.js-first-bites');
const rotatingSlider = document.querySelector('.js-rotating-glide');
const defaultSlider = document.querySelector('.js-glide');

const mountFirstBitesSlider = slider => {
    if (slider === null) return;

    new Glide(slider, {
        type: 'carousel',
        perView: 2,
        gap: 30,
        dragThreshold: false,
        animationDuration: 1200,
        breakpoints: {
            1200: {
                perView: 1
            },
            991: {
                perView: 2
            },
            768: {
                perView: 1
            }
        }
    }).mount();
};

const mountDefaultSlider = slider => {
    if (slider === null) return;

    new Glide(slider, {
        type: 'slider',
        perView: 1,
        gap: 0,
        dragThreshold: false,
        animationDuration: 1000,
    }).mount();
};

const mountRotatingSlider = slider => {
    if (slider === null) return;

    new Glide(slider, {
        type: 'slider',
        perView: 1,
        gap: 0,
        dragThreshold: false,
        animationDuration: 1000,
        autoplay: 5000,
    }).mount();
};

const init = () => {
    mountFirstBitesSlider(firstBitesSlider);
    mountRotatingSlider(rotatingSlider);
    mountDefaultSlider(defaultSlider);
}

init();
